import React from 'react';

import { Box, Divider, Typography } from '@mui/material';

import { CommonComponentProps } from '../pages/types';
import { hexToRgb } from './admin-utils';

interface IngressProps extends CommonComponentProps {
  title?: string;
  paragraph?: string;
  lineColor?: string;
}

const Ingress: React.FC<IngressProps> = ({
  id,
  title = '',
  paragraph = '',
  lineColor = '#000000',
  sx,
}) => {
  return (
    <Box
      id={id}
      sx={{
        maxWidth: '1100px',
        width: '100%',
        margin: '0 auto',
        textAlign: 'center',
        ...sx,
      }}
    >
      <Typography
        variant="h2"
        sx={{
          textAlign: 'center',
        }}
      >
        {title}
      </Typography>
      <Divider
        sx={{
          borderTop: '1px solid #000',
          width: '100%',
          margin: '15px 0px 25px 0px',
          borderColor: lineColor ? `rgba(${hexToRgb(lineColor)}, 0.2)` : '',
        }}
      />
      <Typography variant="body2">{paragraph}</Typography>
    </Box>
  );
};

export default Ingress;
